<form [formGroup]="form">
  <p class="mb-2">{{ title }}</p>
  <div class="d-flex gap-1 sendbox-area">
    <div class="w-75">
      <input type="email" formControlName="email" class="form-control w-100" [placeholder]="inputPlaceholder" />
    </div>
    <div class="w-25">
      <lib-button
        id="sendVoucherAsGift"
        styleClass="btn-primary"
        [disabled]="!form.valid || inProgress"
        [spin]="inProgress"
        (buttonClick)="onSubmit()"
        [label]="buttonLabel | uppercase"
      ></lib-button>
    </div>
  </div>

  <div class="with-errors" *ngIf="!form.valid && form.dirty && formSubmitAttempt">
    <p *ngIf="form.get('email')?.errors?.required">
      {{ 'errors.10003' | translate }}
    </p>
    <p *ngIf="form.get('email')?.errors?.pattern">
      {{ 'errors.10102' | translate }}
    </p>
  </div>
</form>
